import { actionCreator } from 'utils';
import * as BoxTypes from '../types/boxTypes';

const initState = {
    loading: false,
    error: false,
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    listing: {},
    filters: {
        package_name: '',
    },
    add: {
        loading: false,
        error: false,
        success: false,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
};

export default function reducer(state = initState, action) {
    switch (action.type) {
    case BoxTypes.LOAD_BOXES:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(BoxTypes.LOAD_BOXES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(BoxTypes.LOAD_BOXES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case BoxTypes.SET_BOX_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case BoxTypes.SET_BOX_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case BoxTypes.LOAD_EDITABLE_BOX:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(BoxTypes.LOAD_EDITABLE_BOX, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(BoxTypes.LOAD_EDITABLE_BOX, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case BoxTypes.SET_EMPTY_EDITABLE_BOX:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                data: null,
            }),
        });

    case BoxTypes.EDIT_BOX:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(BoxTypes.EDIT_BOX, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
            }),
        });

    case actionCreator(BoxTypes.EDIT_BOX, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    default:
        return state;
    }
}
